export const ITEM_COPY = {
  back: '回到佇列',
  thread: '對話內容',
  olderMessagesHidden: (count: number) => `較早的 ${count} 則訊息未顯示`,
  post: '留言所在的貼文',
  postPending: '正在取得貼文內容…',
  postUnavailable: '無法取得貼文內容，貼文可能已刪除或不再公開',
  postEmpty: '這篇貼文沒有文字內容',
  postPostedAt: (relative: string) => `發佈於 ${relative}`,
  postOpen: (platform: string) => `在 ${platform} 開啟貼文`,
  opensInNewTab: '（在新分頁開啟）',
  postExpand: '顯示全文',
  postCollapse: '收合',
  edited: '已編輯',
  sentOutside: (platform: string) => `在 ${platform} 直接回覆`,
  removed: '這則訊息已被刪除',
  redacted: '內容已依保存期限遮蔽',
  noText: '這則訊息沒有文字內容（請到 Meta 收件匣查看）',
  attachmentSent: {
    inbound: (kinds: readonly string[]) => `客人傳送了${kinds.join('、')}（請到 Meta 收件匣查看）`,
    outbound: (kinds: readonly string[]) => `粉專傳送了${kinds.join('、')}（請到 Meta 收件匣查看）`,
  },
  attachmentKinds: {
    image: '圖片',
    sticker: '貼圖',
    video: '影片',
    audio: '語音訊息',
    file: '檔案',
    other: '附件',
  },
  origin: (channel: string, kind: string) => `${channel}・${kind}`,
  deadline: '回覆期限',
  classification: '分類',
  intent: '意圖',
  language: '語言',
  inDomain: '業務範圍內',
  outOfDomain: '業務範圍外',
  confidence: '信心值',
  unclassified: 'AI 無法分類',
  unclassifiedHint: '自動分類失敗，請人手選擇意圖後再回覆。',
  reclassify: '重新分類',
  claim: '認領',
  release: '釋放認領',
  takeover: '接手認領',
  claimedByMe: '你正在處理這個項目',
  claimExpired: '認領已逾時，現在可以重新認領',
  claimedByOther: (name: string) => `${name} 正在處理`,
  claimExpiresAt: (time: string) => `認領於 ${time} 過期`,
  notFoundTitle: '找不到這個項目',
  notFoundBody: '它可能已被撤回或刪除。',
  loading: '載入項目…',
  loadFailed: '載入項目失敗',
  claimPending: '處理中…',
} as const
